import Subtitle from '../subtitle/Subtitle';

export default class StarterPack extends Phaser.GameObjects.Container {
    private subtitle!: Subtitle;
    private button!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupSubtitle();
        this.setupButton();
    }

    private setupSubtitle(): void {

        this.subtitle = new Subtitle(this.scene, this.x, this.y, this.scene.cache.json.get('i18n')['starter_pack']);
        this.add(this.subtitle);
    }

    private setupButton(): void {
        const x = 0;
        const y = 60;
        const frame = 'gui/popups/shop/bg_starter_pack';

        this.button = this.scene.add.image(x, y, 'atlas', frame);
        this.button.setOrigin(0.5, 0);
        this.button.setInteractive({ useHandCursor: true });
        this.button.on('pointerdown', () => console.log('clicked on the starter pack button'));
        this.add(this.button);
    }
}
